// removed by extract-text-webpack-plugin
module.exports = {"container":"_4sn3zggjzxk7rxvdnwn1x2rjwghnzsg1r2edmcgweasgr6b762n4rpyrkasxut665pv45y79sh3gv3mzf22uykm867bmak8h4fgm3ks-FormulaBar-module-container"};


//////////////////
// WEBPACK FOOTER
// ./src/components/formula-bar/FormulaBar.module.css
// module id = 155
// module chunks = 0